import { createMuiTheme } from '@material-ui/core/styles'
import red from '@material-ui/core/colors/red'
import blue from '@material-ui/core/colors/blue'
export default createMuiTheme({
  overrides: {
    MuiTabs: {
      root: {
        borderRadius: 5,
        backgroundColor: blue[500],
        color: blue[50]
      }
    }
  },
  palette: {
    primary: blue,
    secondary: red
  }
})



// WEBPACK FOOTER //
// ./src/styles/Theme.js